import { render, staticRenderFns } from "./CandleStickTrendsPanel.vue?vue&type=template&id=3d116c1e"
import script from "./CandleStickTrendsPanel.vue?vue&type=script&lang=js"
export * from "./CandleStickTrendsPanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports